import React from "react";

import { TextElement } from "@/components/ui-kit/TextElement/TextElement";
import { CategoryMap, LinkedItem } from "@/types/search";
import { cn } from "@/utils/general";

import Categories from "./Categories";
import styles from "./DefaultSearch.module.scss";
import LinkedItems from "./LinkedItems";
import QuizCTA from "./QuizCTA";
import SearchResultsLayout from "./SearchResultsLayout";

interface DefaultSearchProps {
  categories: CategoryMap;
  title: string;
  faq?: LinkedItem[];
  onClick?: (event: React.MouseEvent<HTMLButtonElement>, item: LinkedItem) => void;
}

/**
 * DefaultSearch renders the search section with categories and FAQs
 */
const DefaultSearch: React.FC<DefaultSearchProps> = ({ categories, title, faq, onClick }) => {
  return (
    <div className="w-full">
      <SearchResultsLayout isReversed={true}>
        <div>
          <TextElement
            element="h2"
            className={cn("title--xsmall text-master-base-black", styles.titleFont)}
          >
            {title}
          </TextElement>
          <Categories categories={categories} />
          <QuizCTA />
        </div>
        {Boolean(faq?.length) && (
          <LinkedItems title="Frequently Asked Questions" items={[...faq]} onClick={onClick} />
        )}
      </SearchResultsLayout>
    </div>
  );
};

export default DefaultSearch;
